import { render, staticRenderFns } from "./AgGrid.vue?vue&type=template&id=2bf099c7"
import script from "./AgGrid.vue?vue&type=script&lang=ts"
export * from "./AgGrid.vue?vue&type=script&lang=ts"
import style0 from "./AgGrid.vue?vue&type=style&index=0&id=2bf099c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports